import { ApiResponse, TokenData, LeadStatus } from '../models';
import * as http from './http';
import ApiService from './service';

export class LeadStatusService extends ApiService {
  public async loadAllLeadStatus() {
    const url = `${this.apiDomain}/api/lead-status`;

    const resposne = await http.get<ApiResponse<LeadStatus[]>>(url, this.store);
    return resposne?.data?.data;
  }
  public async updateLeadStatus(data: LeadStatus, id?: string) {
    const url = `${this.apiDomain}/api/lead-status/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
}
